module.exports = __webpack_public_path__ + "img/web1icon6.018af319.png";